var vm = new Vue({
  el: '#app',
  data: {
    inputText: "",
    inputWords: ""
  },
  computed: {
    words: function () {
      return ('' + this.inputWords)
        .split('\n')
        .filter(function (item) {
          return item.length > 0;
        });
    },
    hists: function () {
      var inputText = this.inputText;

      return this
        .words
        .map(function (word) {
          var regexp = new RegExp(word, "g");
          var count = (inputText.match(regexp) || []).length;

          return {
            word: word,
            count: count
          };
        });
    },
    outputHists: function () {
      return this
        .hists
        .map(function (hit) {
          return hit.word + '    ' + hit.count;
        })
        .join('\n');
    }
  }
});
